import React from "react";

export default function ShareOptions({ url, eleRef }) {
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => eleRef.shareUrl('facebook', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => eleRef.shareUrl('twitter', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="pintrest-share left" onClick={() => eleRef.shareUrl('pintrest', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => eleRef.shareUrl('whatsapp', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        </div>
    );
}